import { render } from "./Instalment.vue?vue&type=template&id=5240e4c8&scoped=true"
import script from "./Instalment.vue?vue&type=script&lang=js"
export * from "./Instalment.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=5240e4c8&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=1&id=5240e4c8&scoped=true&lang=css"
import "@/assets/css/user/pages/keypad.css?vue&type=style&index=2&id=5240e4c8&scoped=true&lang=css"
import "@/assets/css/user/dark/keypad-dark.css?vue&type=style&index=3&id=5240e4c8&scoped=true&lang=css"
import "./Instalment.vue?vue&type=style&index=4&id=5240e4c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5240e4c8"]])

export default __exports__